import React from "react";
import ReactLoading from "react-loading";
const LoadingComponent = ({ type, color,name }) => (


    <div style={{textAlign:"center"}}>
                <ReactLoading  type={type} color={color}  style={{margin:"0 auto",fill:"rgb(50, 152, 233)", height: "64px", width:"64px"}} />
                <h5>{name}</h5>
    </div>
);

export default LoadingComponent;
